/**
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2025-02-17 17:00:33
 */

import {type AnySchema, object, string} from 'yup';

// helpers
import {genericFieldsSchema, HandleProps} from '~/helpers/form-fields';

// types
import type {PersonalLetterField, PersonalLetterFields} from './fields-info';

export type PersonalLetterProps = HandleProps<PersonalLetterFields>

export const schema = object<PersonalLetterFields, Record<PersonalLetterField, AnySchema>>()
  .shape({
    postage_type: string().required('Postage Type is required'),
    envelope_type: string().required('Envelope type is required'),
    ...genericFieldsSchema,
  });
